import { render, staticRenderFns } from "./KABookingSheet.vue?vue&type=template&id=c2165ace&scoped=true&"
import script from "./KABookingSheet.vue?vue&type=script&lang=js&"
export * from "./KABookingSheet.vue?vue&type=script&lang=js&"
import style0 from "./KABookingSheet.vue?vue&type=style&index=0&id=c2165ace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2165ace",
  null
  
)

export default component.exports